/* eslint-disable max-lines-per-function */
import { Routes, Route, useLocation } from 'react-router-dom';
import {
  DefaultPage,
  LoadingPage,
  LoginPage,
  LogoutPage,
  ProfilePage,
} from '../../../pages';
import { Vertraege, Controlling, Dienstplan, Termine } from '../../../domain'; // Add import for new domain here
import { useEffect } from 'react';
import { managerV1BaseUrl } from '../../../utils/util.ts';
import { Arbeitszeiten } from '../../../domain/arbeitszeiten/Arbeitszeiten.tsx';
import { AuthorizedPage } from '@/app/Routes/AuthenticatedRoutes/AuthorizedPage.tsx';
import { NewsfeedDialog } from '@/domain/navigation/features/navigation/components/NewsfeedDialog/NewsfeedDialog.tsx';

export const NavigateToV1 = () => {
  useEffect(() => {
    window.location.replace(managerV1BaseUrl);
  }, []);
  return <LoadingPage />;
};

export function AuthenticatedRoutes() {
  const location = useLocation();

  return (
    <>
      <Routes location={location.state?.background || location}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/*" element={<NavigateToV1 />} />
        <Route
          path="/profile"
          element={
            <AuthorizedPage>
              <DefaultPage>
                <ProfilePage />
              </DefaultPage>
            </AuthorizedPage>
          }
        />
        <Route
          path="/controlling/*"
          element={
            <AuthorizedPage>
              <DefaultPage>
                <Controlling />
              </DefaultPage>
            </AuthorizedPage>
          }
        />
        <Route
          path="/vertraege/*"
          element={
            <AuthorizedPage>
              <DefaultPage>
                <Vertraege />
              </DefaultPage>
            </AuthorizedPage>
          }
        />
        <Route
          path="/arbeitszeiten/*"
          element={
            <AuthorizedPage>
              <DefaultPage>
                <Arbeitszeiten />
              </DefaultPage>
            </AuthorizedPage>
          }
        />
        <Route
          path="/dienstplan/*"
          element={
            <AuthorizedPage>
              <DefaultPage>
                <Dienstplan />
              </DefaultPage>
            </AuthorizedPage>
          }
        />
        <Route
          path="/termine/*"
          element={
            <AuthorizedPage>
              <DefaultPage>
                <Termine />
              </DefaultPage>
            </AuthorizedPage>
          }
        />
        <Route path="/logout" element={<LogoutPage />} />
      </Routes>
      {location.state?.background && (
        <Routes>
          <Route path="/news/:id" element={<NewsfeedDialog />} />
        </Routes>
      )}
    </>
  );
}
